const divElement = document.createElement('div');
const textElement = document.createElement('p');
const closeButton = document.createElement('span');
closeButton.textContent = '\u2A09';
closeButton.style.color = 'white';
closeButton.style.fontSize = '18px';
closeButton.style.fontWeight = 'bold';
closeButton.style.marginLeft = '10px';
closeButton.classList.add('h-cursor-pointer');
textElement.classList.add('h-font-bold');
divElement.appendChild(textElement);
divElement.appendChild(closeButton);
divElement.classList.add('b-top-notification');

export async function modal (status, text) {
    if (status === 'error' && text) {
        divElement.classList.add('active');
        divElement.classList.add('active-error');
        document.body.appendChild(divElement);
        textElement.innerHTML = text;
        setTimeout(() => {
            divElement.remove();
        }, 3000);
    } else {

    }
}

closeButton.addEventListener('click', () => {
    divElement.remove();
})
